import type { DemoEngagementLevel } from './superOrgTypes';

export const DEMO_LEVEL_LABEL: Record<DemoEngagementLevel, string> = {
  sin_uso: 'Sin uso',
  frio: 'Frío',
  poco: 'Poco',
  activo: 'Activo',
  intenso: 'Intenso',
};

export const DEMO_LEVEL_COLOR: Record<DemoEngagementLevel, { bg: string; fg: string; border: string }> = {
  sin_uso: { bg: '#f1f5f9', fg: '#475569', border: '#e2e8f0' },
  frio: { bg: '#eff6ff', fg: '#1d4ed8', border: '#bfdbfe' },
  poco: { bg: '#fffbeb', fg: '#b45309', border: '#fde68a' },
  activo: { bg: '#ecfdf5', fg: '#047857', border: '#a7f3d0' },
  intenso: { bg: '#f5f3ff', fg: '#6d28d9', border: '#ddd6fe' },
};

export function formatDemoDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('es-UY', { dateStyle: 'short', timeStyle: 'short' });
}
